/* ==========================================================================
   Coffee Club · collection card
   assets/cc-collection.js

   Delegacion de eventos en document: no hay init por card, asi que las cards
   que entran despues (infinite scroll, editor de tema, filtros ajax) funcionan
   sin re-inicializar nada.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__ccCollectionBound) return;
  window.__ccCollectionBound = true;

  var SELECTOR_FORM = '[data-cc-form]';

  function getVariants(form) {
    var el = form.querySelector('[data-cc-variant-data]');
    if (!el) return [];
    if (form.__ccVariants) return form.__ccVariants;
    try {
      form.__ccVariants = JSON.parse(el.textContent);
    } catch (err) {
      form.__ccVariants = [];
    }
    return form.__ccVariants;
  }

  /* Matchea la variante respetando la POSICION real de cada opcion.
     El bug anterior: las opciones con un solo valor no se renderizan, pero el
     array de seleccionados se armaba denso y se comparaba por indice corrido,
     asi que se podia agregar al carrito una variante distinta a la elegida. */
  function syncVariant(form) {
    var variants = getVariants(form);
    if (!variants.length) return;

    var selected = {};
    form.querySelectorAll('[data-cc-option]:checked').forEach(function (input) {
      selected[parseInt(input.dataset.optionIndex, 10)] = input.value;
    });

    var indexes = Object.keys(selected);

    function matches(variant) {
      return indexes.every(function (i) {
        return variant.options[i] === selected[i];
      });
    }

    /* Se prefiere una variante disponible; si ninguna lo esta, se toma la
       primera que coincida para que el mensaje de error venga del carrito. */
    var match =
      variants.find(function (v) {
        return v.available && matches(v);
      }) ||
      variants.find(matches);

    if (!match) return;

    var idInput = form.querySelector('[data-cc-variant-input]');
    if (idInput) idInput.value = match.id;
  }

  function updatePlanPrice(form, input) {
    var saleEl = form.querySelector('[data-cc-price-sale]');
    if (saleEl && input.dataset.salePrice) {
      saleEl.textContent = input.dataset.salePrice;
    }
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches) return;

    var form = input.closest(SELECTOR_FORM);
    if (!form) return;

    if (input.matches('[data-cc-option]')) {
      syncVariant(form);
      return;
    }

    if (input.matches('[data-cc-plan-input]')) {
      updatePlanPrice(form, input);
    }
  });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-cc-subscribe-btn]');
    if (!btn) return;

    var form = btn.closest(SELECTOR_FORM);
    if (!form) return;

    addToCart(form, btn);
  });

  function addToCart(form, btn) {
    var errorEl = form.querySelector('[data-cc-error]');
    if (errorEl) errorEl.textContent = '';

    var variantInput = form.querySelector('[data-cc-variant-input]');
    var variantId = variantInput ? variantInput.value : form.dataset.defaultVariantId;

    var qtyInput = form.querySelector('[data-quantity-field]');
    var quantity = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;

    var checkedPlan = form.querySelector('[data-cc-plan-input]:checked');
    var sellingPlan = checkedPlan ? checkedPlan.value : null;

    if (!variantId) {
      if (errorEl) errorEl.textContent = form.dataset.errorVariant;
      return;
    }

    if (!sellingPlan) {
      if (errorEl) errorEl.textContent = form.dataset.errorPlan;
      return;
    }

    btn.classList.add('is-loading');
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [
          {
            id: parseInt(variantId, 10),
            quantity: quantity,
            selling_plan: parseInt(sellingPlan, 10)
          }
        ]
      })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          if (errorEl) {
            errorEl.textContent = result.data.description || form.dataset.errorGeneric;
          }
          return;
        }

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      })
      .catch(function () {
        if (errorEl) errorEl.textContent = form.dataset.errorGeneric;
      })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  }
})();
